import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import { HashRouter, Route, Switch, useLocation } from "react-router-dom";

import { getCurrentUser } from "modules/current_user/actions";
import PacmanLoader from "react-spinners/PacmanLoader";
import routes from "modules/2_routes/outlook";
import Login from "modules/auth/Login";
import { ensureAccessToken } from "modules/auth/api";
import { clearAccessToken } from "modules/auth/token";

function mapStateToProps(state) {
  return {
    current_user: state.current_user,
  };
}

const OutlookPageTracker = ({ getCurrentUser }) => {
  const location = useLocation();
  useEffect(() => {
    getCurrentUser(location.pathname);
  }, [location]);
  return null;
};

const Router = (props) => {
  const { current_user } = props;
  const [ready, setReady] = useState(false);
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const bootstrap = async () => {
      const token = await ensureAccessToken();
      if (cancelled) return;
      if (!token) {
        setAuthed(false);
        setReady(true);
        return;
      }
      setAuthed(true);
      try {
        await props.getCurrentUser();
      } catch (_e) {
        clearAccessToken();
        setAuthed(false);
      }
      if (!cancelled) setReady(true);
    };
    bootstrap();
    return () => {
      cancelled = true;
    };
  }, []);

  const onLoginSuccess = async () => {
    setAuthed(true);
    await props.getCurrentUser();
    setReady(true);
  };

  if (!ready) {
    return <PacmanLoader />;
  }

  if (!authed) {
    return <Login onSuccess={onLoginSuccess} />;
  }

  if (_.isEmpty(current_user)) {
    return <PacmanLoader />;
  }

  return (
    <HashRouter>
      <OutlookPageTracker getCurrentUser={props.getCurrentUser} />
      <Switch>
        {_.map(routes, (route, i) => {
          return <Route key={i} path={route.path} exact={route.exact} name={route.name} component={route.component} />;
        })}
      </Switch>
    </HashRouter>
  );
};

export default connect(mapStateToProps, { getCurrentUser })(Router);
